import { useQuery } from '@tanstack/react-query';
import { azureGroupSyncApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** Rows per log page — the drawer's page-count arithmetic depends on it. */
export const AZURE_GROUP_SYNC_LOG_PAGE_SIZE = 25;

export function useAzureGroupSyncMappings() {
  return useQuery({
    queryKey: queryKeys.azureGroupSync.mappings(),
    queryFn: ({ signal }) =>
      azureGroupSyncApiClient.listMappings(toCancelToken(signal)),
    meta: { errorContext: 'Azure Group Sync mappings' },
  });
}

export function useAzureGroupSyncStatus() {
  return useQuery({
    queryKey: queryKeys.azureGroupSync.status(),
    queryFn: ({ signal }) =>
      azureGroupSyncApiClient.getStatus(toCancelToken(signal)),
    meta: { errorContext: 'Azure Group Sync status' },
  });
}

export function useAzureGroupSyncLogs(page: number, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.azureGroupSync.logs(page),
    queryFn: ({ signal }) =>
      azureGroupSyncApiClient.getLogs(
        page,
        AZURE_GROUP_SYNC_LOG_PAGE_SIZE,
        toCancelToken(signal),
      ),
    enabled,
    meta: { errorContext: 'Azure Group Sync logs' },
  });
}

export function useAzureGroupSyncMemberships(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.azureGroupSync.memberships(),
    queryFn: ({ signal }) =>
      azureGroupSyncApiClient.listMemberships(toCancelToken(signal)),
    enabled,
    meta: { errorContext: 'Azure Group Sync memberships' },
  });
}
